import { Component, OnInit, HostListener, Input, OnChanges, SimpleChange, ViewChild} from '@angular/core';
import Swal from 'sweetalert2';
import { ChartType } from "angular-google-charts";
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { AppSettingService } from '../app.service';
import { StateAPIService } from '../location/location-api.service';
import { BLSAPIService } from './bls.service';

@Component({
	selector: 'app-bls-regional-statistics',
	templateUrl: './bls-regional-statistics.component.html',
	standalone: false
})
export class BLSRegionalStatisticsComponent implements OnInit {
	@Input() zipCode: string = "92123";
	@Input() state: string = "CA";
	@Input() stateStatistics: boolean = false;
	@Input() includeCyberEconomy: boolean = false;

	@ViewChild('regionOption') regionOption: NgbDropdown;

	constructor(
		private stateAPI: StateAPIService
	) { }

	allStates: any = null;
	formData: any = {
		schoolZipCode: "92123",
		schoolState: { Abbr: "CA", Name: "California" }
	};
	displayZipCodeWarning: boolean = false;

	private hasLoaded: boolean = false;
	falseValue: boolean = false;
	toggled: boolean = AppSettingService.widgetMobile();
	isMobile: boolean = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event']) onResize(e: any): void {
		this.setDisplay();
	}

	private setDisplay(): void {
		this.isMobile = AppSettingService.widgetMobile();
		// do not load chart unless it is either not isMobile or it is expanded already
		if (!this.toggled) {
			if (!this.isMobile) {
				this.chartReady = false;
				setTimeout(() => { this.loadChart(); }, 500);
			}
			else {
				this.chartReady = true;
			}
		}
	}

	toggleCollapse(): void {
		this.toggled = !this.toggled;
		this.setDisplay();
	}

	// create two equal rows for the region Statistics charts based on the gridster height
	chartReady: boolean = false;
	private loadChart(): void {
		let tbl = document.getElementById("tblRegionalStatistics");
		let gi = tbl.parentElement.parentElement;
		if (gi == null || gi.clientHeight === 0 || tbl == null) {
			return;
		}
		let rows = this.includeCyberEconomy ? 3 : 2;
		let tdLocalEconomy = (document.getElementById('trLocalEconomy')?.children[0] ?? null) as HTMLTableDataCellElement;
		let tdChart0 = (document.getElementById('trChart0').children[0]) as HTMLTableDataCellElement;
		let tdChart1 = (document.getElementById('trChart1').children[0]) as HTMLTableDataCellElement;
		if (this.isMobile) {
			if (this.includeCyberEconomy) {
				tdLocalEconomy.style.height = null;
			}
			tdChart0.style.height = null;
			tdChart0.style.height = null;
			tbl.style.height = null;
		}
		else {
			let hi: number = parseInt(gi.style.height.replace("px", ""));
			tbl.style.height = hi.toString() + "px";
			if (this.includeCyberEconomy) {
				tdLocalEconomy.style.height = ((hi - 75) / rows) + "px";;
			}
			tdChart0.style.height = ((hi - 75) / rows) + "px";
			tdChart1.style.height = ((hi - 75) / rows) + "px";
			this.chartReady = true;
		}
	}

	ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
		if (changes["formData.schoolZipCode"]) {
			if (isNaN(this.formData.schoolZipCode)) {
				this.displayZipCodeWarning = true;
			}
			else {
				this.displayZipCodeWarning = false;
			}
		}
	}

	locationChange(e: any, option: string): void {
		let state = "";
		let zipCode = "";
		if (option === 'state') {
			state = this.formData.schoolState.Abbr;
		}
		else {
			if (isNaN(this.formData.schoolZipCode) || this.formData.schoolZipCode.length !== 5) {
				this.displayZipCodeWarning = true;
				e.stopPropagation();
				return;
			}
			else {
				this.displayZipCodeWarning = false;
			}
			zipCode = this.formData.schoolZipCode;
		}
		this.zipCode = zipCode;
		this.state = state;
		this.regionOption.close();
	}

	private getState(): void {
		this.stateAPI.getAllStates().subscribe({
			next: (response: any) => {
				this.allStates = response;
				if (this.allStates != null && this.allStates.length > 0) {
					if (this.formData.schoolState == null) {
						this.formData.schoolState = this.allStates[0];
					}
					else {
						// lookup the state
						this.formData.schoolState = this.allStates.filter((x: any, i: any) => { return x.Abbr === this.formData.schoolState.Abbr; })[0];
					}
				}
			},
			error: (err: any) => {
				console.log(err);
			}
		});
	}

	ngOnInit(): void {
		if (this.hasLoaded === false) {
			if (!this.toggled) {
				console.log('BLSRegionalStatistics loading...');
				this.formData.schoolZipCode = this.zipCode;
				this.formData.schoolState = { Abbr: this.state, Name: "" };
				this.getState();
				this.setDisplay();
			}
		}
	}
}



@Component({
	selector: 'app-bls-report',
	templateUrl: './bls-report.component.html',
	standalone: false
})
export class BLSReportComponent implements OnInit  {
	@Input() reportType: string = "";
	@Input() zipCode: string = "";
	@Input() state: string = "";
	@Input() periods: number = 4;
	@Input() onlyit: boolean = false;
	@Input() includeNational: boolean = true;

	constructor(
		private blsAPI: BLSAPIService
	) { }

	directiveTitle: string = "";
	componentName = 'BLSReport' + this.reportType;
	showBackCard: boolean = false;
	retrievingData: boolean = true;
	reportTypeId:number = 0;
	compares:any = null;
	localName: string = "";
	nationalName: string = "";
	chartType: ChartType = ChartType.ColumnChart;
	chartColors: string[] = [];
	chartLegend: string = "fas fa-business-time";
	hasLocalData: boolean = false;

	isMobile = AppSettingService.widgetMobile();

	private setDisplay(): void {
		this.isMobile = AppSettingService.widgetMobile();
		this.createChart();
	}

	toggleBackCard() : void {
		this.showBackCard = !this.showBackCard;
		//redraw chart when switch to front end card
		if (!this.showBackCard) {
			this.setDisplay();
		}
	}

	@HostListener('window:resize', ['$event']) onResize(e: any): void {
		this.setDisplay();
	}

	private createChart() {
		this.chartData.init();
		setTimeout(() => {
			this.drawChart();
		}, 2000);
	}

	chartData = {
		reportType: "",
		isReady: false,
		title: "",
		type: ChartType.ColumnChart,
		data: [] as any[],
		columnNames: [] as any[],
		options: {} as any,
		formatters: [] as any[],
		width: 200,
		height:200,
		init: () => {
			this.chartData.isReady = false;
			this.chartData.title = "";
			this.chartData.type = ChartType.ColumnChart;
			this.chartData.data = [];
			this.chartData.columnNames = [];
			this.chartData.options = {};
			this.chartData.formatters = [];
		}
	};

	private drawChart(): void {
		if (this.retrievingData || this.compares == null) {
			return;
		}
		this.chartData.reportType = this.reportType;
		let dvWidget = document.getElementById('dv' + this.componentName);
		let dvChart = document.getElementById('dv' + this.componentName + "Chart");
		if (dvWidget == null || dvChart == null) {
			return;
		}
		if (!this.isMobile) {
			this.chartData.height = dvChart.clientHeight;
		}
		else if (this.isMobile) {
			this.chartData.height = 200;
		}
		this.chartData.width = dvChart.clientWidth;

		// gather data
		this.localName = this.compares.LocalName;
		this.nationalName = this.includeNational ? this.compares.NationalName : "";
		var result = this.compares.Result;
		this.hasLocalData = false;
		
		this.chartData.type = ChartType.ColumnChart;

		if (this.includeNational) {
			this.chartData.columnNames = ['Period', { type: 'number', role: 'data' }, { type: 'number', role: 'data' }];
		}
		else {
			this.chartData.columnNames = ['Period', { type: 'number', role: 'data' }];
		}

		for (var i = 0; result != null && i < result.length; i++) {
			this.hasLocalData = result[i].LocalValue !== "" ? true : this.hasLocalData;
			// if monthly report, display Jan 2019, Mar 2018. For Quarter, display Q1 2019, Q2 2019, else just the year...
			if (result[i].Period.indexOf("M") == 0) {
				if (this.includeNational) {
					// need to convert UnemploymentRate to decimal percent, such as 3.5 to 0.035 in order to add % sign. UnemploymentRate is monthly data
					if (this.reportType === "UnemploymentRate")
						this.chartData.data.push([
							result[i].PeriodName.substring(0, 3) + " " + result[i].Year,
							parseFloat(result[i].LocalValue) / 100.0,
							parseFloat(result[i].NationalValue) / 100.0
						]);
					else
						this.chartData.data.push([
							result[i].PeriodName.substring(0, 3) + " " + result[i].Year,
							parseFloat(result[i].LocalValue),
							parseFloat(result[i].NationalValue)
						]);
				}
				else {
					if (this.reportType === "UnemploymentRate")
						this.chartData.data.push([
							result[i].PeriodName.substring(0, 3) + " " + result[i].Year,
							parseFloat(result[i].LocalValue) / 100.0]
						);
					else
						this.chartData.data.push([
							result[i].PeriodName.substring(0, 3) + " " + result[i].Year,
							parseFloat(result[i].LocalValue)
						]);
				}
			}
			else if (result[i].Period.indexOf("Q") == 0) {
				if (this.includeNational)
					this.chartData.data.push([
						result[i].Period.replace("0", "") + " " + result[i].Year,
						parseFloat(result[i].LocalValue),
						parseFloat(result[i].NationalValue)
					]);
				else
					this.chartData.data.push([
						result[i].Period.replace("0", "") + " " + result[i].Year,
						parseFloat(result[i].LocalValue)]);
			}
			else {
				if (this.includeNational)
					this.chartData.data.push([
						result,
						parseFloat(result[i].LocalValue),
						parseFloat(result[i].NationalValue)
					]);
				else
					this.chartData.data.push([
						result, parseFloat(result[i].LocalValue)
					]);
			}
		}

		if (this.reportType === "UnemploymentRate") {
			this.chartData.formatters.push(
				{ colIndex: 1, formatter: new google.visualization.NumberFormat({ pattern: '#.#%' }) }
			);
			if (this.includeNational) {
				this.chartData.formatters.push(
					{ colIndex: 2, formatter: new google.visualization.NumberFormat({ pattern: '#.#%' }) }
				);
			}
		}
		else if (this.reportType === "WeeklyWage") {
			this.chartData.formatters.push(
				{ colIndex: 1, formatter: new google.visualization.NumberFormat({ pattern: '$#,###,###,###.#' }) }
			);
			if (this.includeNational) {
				this.chartData.formatters.push(
					{ colIndex: 2, formatter: new google.visualization.NumberFormat({ pattern: '$#,###,###,###.#' }) }
				);
			}
		}

		this.chartData.options = {
			legend: 'none',
			colors: this.chartColors,
			vAxis: { format: this.reportType === "UnemploymentRate" ? '#.#%' : this.reportType === "WeeklyWage" ? '$#,###,###,###.#' : '' }
		};

		this.chartData.isReady = true;
		//console.log(this.chartData);
	}

	private downloadUnemploymentRate():void {
		this.retrievingData = true;
		this.blsAPI.getUnemploymentRate(this.zipCode, this.state, this.periods).subscribe(
			response => {
				this.compares = response;
				this.retrievingData = false;
				this.createChart();
			},
			error => {
				console.log(error);
				Swal.fire("Oops", "Not able to get establishments, please reload page", "error");
				this.retrievingData = false;
			}
		);
	}

	private downloadEmployment(): void {
		this.retrievingData = true;
		this.blsAPI.getEmployment(this.zipCode, this.state, this.periods, this.onlyit).subscribe(
			response => {
				this.compares = response;
				this.retrievingData = false;
				this.createChart();
			},
			error => {
				console.log(error);
				Swal.fire("Oops", "Not able to get establishments, please reload page", "error");
				this.retrievingData = false;
			}
		);
	}

	private downloadWeeklyWage(): void {
		this.retrievingData = true;
		this.blsAPI.getWeeklyWage(this.zipCode, this.state, this.periods, this.onlyit).subscribe(
			response => {
				this.compares = response;
				this.retrievingData = false;
				this.createChart();
			},
			error => {
				console.log(error);
				Swal.fire("Oops", "Not able to get establishments, please reload page", "error");
				this.retrievingData = false;
			}
		);
	}

	private downloadEstablishment(): void {
		this.retrievingData = true;
		this.blsAPI.getEstablishment(this.zipCode, this.state, this.periods, this.onlyit).subscribe(
			response => {
				this.compares = response;
				this.retrievingData = false;
				this.createChart();
			},
			error => {
				console.log(error);
				Swal.fire("Oops", "Not able to get establishments, please reload page", "error");
				this.retrievingData = false;
			}
		);
	}

	private download() {
		// if we already have comparison data, skip and go to drawchart directly
		if (this.compares != null) {
			this.createChart();
		}
		else {
			switch (this.reportTypeId) {
				case 1:
					this.downloadUnemploymentRate(); break;
				case 2:
					this.downloadEmployment(); break;
				case 3:
					this.downloadWeeklyWage(); break;
				case 4:
					this.downloadEstablishment(); break;
			}
		}
	}

	ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
		// do nothing if we have not done first run
		if (this.compares != null && (changes["zipCode"] || changes["state"])) {
			this.localName = "";
			this.nationalName = "";
			this.compares = null;
			this.download();
		}
	}

	ngOnInit(): void {
		switch (this.reportType) {
			case "UnemploymentRate":
				this.reportTypeId = 1;
				this.directiveTitle = "Unemployment Rate %";
				this.chartColors = ["#24B4D3", "#116996"];
				this.chartLegend = "fas fa-business-time";
				break;
			case "Employment":
				this.reportTypeId = 2;
				this.directiveTitle = "Total Employed (" + (this.onlyit ? "Information" : "All Industries") + ")";
				this.chartColors = ["#B4DF82", "#6B874A"];
				this.chartLegend = "icnUsers";
				break;
			case "WeeklyWage":
				this.reportTypeId = 3;
				this.directiveTitle = "Average Weekly Wages (" + (this.onlyit ? "Information" : "All Industries") + ")";
				this.chartColors = ["#39C19F", "#088767"];
				this.chartLegend = "icnMoneyBill1";
				break;
			case "Establishment":
				this.reportTypeId = 4;
				this.directiveTitle = "Total Establishments (" + (this.onlyit ? "Information" : "All Industries") + ")";
				this.chartColors = ["#F3C23D", "#F37D3D"];
				this.chartLegend = "fas fa-building";
				break;
			default:
				Swal.fire("Oops", "Unknown report type (" + this.reportType + ")", "error");
				return;
		}
		// preload google chart to use "google.visualization type
		// bind the download function to allow google calling back
		this.download = this.download.bind(this);
		google.charts.load('current', { 'packages': ['corechart'] });
		google.charts.setOnLoadCallback(this.download);
	}
}
